/**
 * @file
 * A JavaScript file for making selectboxes customizable
 *
 */

(function (Drupal, $) {
  Drupal.behaviors.niceSelect = {
    attach: function (context) {
      "use strict";
      $("select").niceSelect();

      $(".nice-select .list").each(function () {
        if ($(this).outerHeight() > 500) $(this).addClass("scrollable");

        if ($(this).find("li").length == 1) {
          console.log($(this).closest(".nice-select").addClass("one-option"));
        }
      });
    },
  };
})(Drupal, jQuery);
